// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__1_E1H","fullHeigth":"Loader_fullHeigth__3jeOl","loader":"Loader_loader__2xCh6"};